/* eslint-disable react/style-prop-object */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { getCurrencyCode } from 'utils/helpers';

const propTypes = {
  id: PropTypes.string,
  value: PropTypes.number,
  style: PropTypes.string,
};

const UpgradeProductItem = ({ id, value, style }) => (
  <div className="upgrade-product__item">
    <FormattedMessage id={`offer.upgrade.${id}`} />
    <div className="upgrade-product__item-value">
      {style === 'percent'
        ? (
          <FormattedNumber
            style="percent"
            minimumFractionDigits={2}
            maximumFractionDigits={2}
            value={value / 100}
          />
        )
        : (
          <FormattedNumber
            style="currency"
            currency={getCurrencyCode()}
            value={value}
          />
        )}
    </div>
  </div>
);

UpgradeProductItem.propTypes = propTypes;

export default UpgradeProductItem;
